import { SET_ASSIGN_TO_FILTER_DATA } from "../../Actions/ActionConstants";

function assignToDataReducer(state = null, action) {
    switch (action.type) {
        case SET_ASSIGN_TO_FILTER_DATA:
            if (action.data) { return action.data; }
            else { return null }
        default:
            return state;
    }
}
export default assignToDataReducer